import React from 'react'
import { Box, Stack, } from "@mui/material";
import Skeleton from '@mui/material/Skeleton';

type SettingCardProps = {
    children?: React.ReactNode
    loading?: Boolean
    title?: String
    titleTooltip?: JSX.Element
}

export const SettingBox: React.FC<SettingCardProps> = ({
    children,
    loading=false,
    title="",
    titleTooltip=<></>
   }) => {

    return (
        <Box className='setting-wrapper' sx={{
            background: '#fff',
            marginBottom: '20px',
            border: '1px solid #E0E0E0',
            borderRadius: '4px',
            minHeight: '80px',
            boxSizing: 'border-box',
            padding: "24px"
        }}>
            <Box className='setting-content'>
                <Stack>
                    {
                        loading ? <Skeleton animation="wave" sx={{ width: '200px', height: '20px' }}/> :
                            <Box className='setting-content-title' sx={{
                                fontFamily: 'Montserrat',
                                fontWeight: '700',
                                fontSize: '18px',
                                lineHeight: "160%",
                                color: '#212121',
                                marginBottom: "32px"
                            }}>{title}{titleTooltip}</Box>
                    }

                </Stack>
                {children}

            </Box>
        </Box>
    );
}
